import { ALL_ITEMS_PAGE_SIZE } from '../../config/constants'

import type { PaginationValue } from './pagination.types'

/**
 * Page sizes available to select in page size selector.
 */
export const PAGINATION_PAGE_SIZES = [10, 20, 30, 50, 100]

/**
 * Default page size.
 */
export const PAGINATION_DEFAULT_PAGE_SIZE = 10

/**
 * Location parameter name to store pagination page.
 */
export const PAGINATION_PAGE_PARAM = 'page'

/**
 * Location parameter name to store pagination page size.
 */
export const PAGINATION_PAGE_SIZE_PARAM = 'page_size'

/**
 * Default pagination value.
 */
export const PAGINATION_DEFAULT_VALUE: PaginationValue = {
  page: 0,
  pageSize: PAGINATION_DEFAULT_PAGE_SIZE,
  count: 0,
}

/**
 * Pagination value for all loaded items.
 */
export const PAGINATION_ALL_ITEMS_VALUE: PaginationValue = {
  page: 0,
  pageSize: ALL_ITEMS_PAGE_SIZE,
  count: 0,
}
